import { Button, Icon } from '@aqarmap/aqarmap-ui';
import { useEffect, useState } from 'react';
import {
  useGetSectionsQuery,
  useUserHasRentalPackageQuery,
} from '~/redux/api/userApiSlice';
import {
  AddListingInitializeType,
  SectionsEnum,
  SectionType,
} from '~addListing/types';
import { UseFormSetValue } from 'react-hook-form';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const Section = ({
  selectedSection,
  setSelectedSection,
  setValue,
}: {
  selectedSection?: SectionType;
  setSelectedSection: React.Dispatch<
    React.SetStateAction<SectionType | undefined>
  >;
  setValue: UseFormSetValue<AddListingInitializeType>;
}) => {
  const { t } = useTranslation('app');
  const { locale } = useParams();
  const { data, isLoading, isSuccess, refetch } = useGetSectionsQuery();
  const [forSaleIsDisabled, setForSaleIsDisabled] = useState(false);
  const {
    data: userHasRentalPackageData,
    isSuccess: userHasRentalPackageIsSuccess,
  } = useUserHasRentalPackageQuery(null);

  useEffect(() => {
    if (isSuccess) {
      setValue('section', data.data[0].id);
      setSelectedSection(data.data[0]);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (selectedSection) {
      setValue('section', selectedSection.id);
    }
  }, [selectedSection]);

  useEffect(() => {
    if (
      userHasRentalPackageIsSuccess &&
      isSuccess &&
      userHasRentalPackageData.hasRentalPackage
    ) {
      setForSaleIsDisabled(userHasRentalPackageData.hasRentalPackage);
      setSelectedSection(
        data.data.find(
          (section: SectionType) => section.slug !== SectionsEnum.FOR_SALE,
        ),
      );
    }
  }, [userHasRentalPackageIsSuccess, userHasRentalPackageData, isSuccess]);

  useEffect(() => {
    refetch();
  }, [locale]);

  return (
    <div className="w-full flex flex-col gap-1.5x">
      <p className="text-title_4 flex flex-col gap-2x">{t('chooseSection')}</p>
      {isLoading ? (
        <Skeleton height={40} width="100%" borderRadius={12} />
      ) : (
        <div
          className={`flex w-full rounded-[12px] border border-gray ${forSaleIsDisabled ? 'bg-gray_light_2' : 'bg-white '}`}
        >
          {data.data.map((section: SectionType) => (
            <Button
              key={section.id}
              variant="link"
              size="medium"
              disabled={
                section.slug === SectionsEnum.FOR_SALE
                  ? forSaleIsDisabled
                  : false
              }
              onClick={() => setSelectedSection(section)}
              className={`flex-1 items-center !rounded-[12px] no-underline hover:no-underline
                ${
                  section?.slug === SectionsEnum.FOR_SALE && forSaleIsDisabled
                    ? 'hover:!bg-gray_light_2 !text-gray__dark_1 hover:!text-gray__dark_1 !bg-gray_light_2'
                    : ''
                } 
                ${
                  section?.slug === selectedSection?.slug
                    ? '!bg-blue_light_2 !border-blue_light_2 !text-link'
                    : 'border-gray !text-gray__dark_1 !text-body_2 hover:bg-white'
                }`}
            >
              <Icon
                name={
                  section.slug === SectionsEnum.FOR_RENT ? 'dollar' : 'money'
                }
                size="sm"
                className="w-[24px] h-[24px]"
              />
              {section.title}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Section;
